angular.module('unergie.main')
.controller('newPdl2Ctrl', (FrontErrorCatcher, DynamicScriptLoaderService) => {
    DynamicScriptLoaderService.load('commons/newPdlB2G.js')
})
